export class WebUtils {
  /**
   * HTMLエンコードした文字かえす
   * @param  {[type]} value [description]
   * @return {[type]}       [description]
   */
  static htmlEncode(value: string) {
    const div = document.createElement('div');
    div.innerText = value;
    return div.innerHTML;
  }

  /**
   * HTMLエンコードされた文字列をデコードする
   */
  static htmlDecode(value: string) {
    const div = document.createElement('div');
    div.innerHTML = value;
    return div.innerText;
  }

  /**
   * ロケーションのクエリパラメータをオブジェクト配列にして返す
   * @param locationObj
   */
  static queryToArray(locationObj: Location): { name: string; value: string }[] {
    const href = locationObj.href;
    if (!href) return [];
    const query = href.split('?')[1];
    if (!query) return [];
    const items = query.split('&');
    if (!items) return [];
    return items.map((item) => {
      const data = item.split('=');
      return { name: data[0], value: data[1] };
    });
  }
  static getQueryItem(name: string, locationObj: Location): string | null {
    const queryArry = this.queryToArray(locationObj);
    if (queryArry.length === 0) return null;
    const items = queryArry.filter((item) => item.name === name);

    if (items.length === 0) return null;
    const item = items[0];

    if (!item) return null;
    if (!item.value) return null;

    return decodeURIComponent(item.value);
  }
}
